import { h } from "preact";
import { observer } from "mobx-react";
function FieldError({ errors }) {
    // TODO: which class is proper? help-block or m-form__validation-info? (are used alternately)
    return h("p", { class: "help-block m-form__validation-info" }, errors[0]);
}
export default observer(FieldError);
